// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2KxhT","smallLinkTypography":"_11lfI","titleTypography":"_2MP9z","cardTitleTypography":"SrqGJ","nameCell":"_1xci2","truncate":"_2bXGn","base":"_2baym","noAccountsAndLoans":"_20DTy","buttonContainer":"_1kFD8"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/components/AccountAndLoan/AccountAndLoanList.scss
// module id = 776
// module chunks = 0